import React from "react";
import { IAlternatives, Isetences } from "../interfaces/interface";
import { getRequest, postRequest } from "../functions/api_functions";
import { useAccessContext } from "../contexts/access_context";
import { Box,FormControlLabel,Pagination,Radio,RadioGroup,Typography,CircularProgress,Alert,Accordion,AccordionSummary,AccordionDetails, PaginationItem, } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"; // Ícone para o Accordion

// Tipo de resposta da API
type SentenceResponse = {
  status_code: number;
  sentences: Isetences[];
};

type ResponseResponse = {
  status_code: number;
}

const SentencesStudents: React.FC = () => {
  const { access_data } = useAccessContext();
  const [loading, setLoading] = React.useState(true);
  const [sentences, setSentences] = React.useState<Isetences[]>([]);
  const [alternatives, setalternatives] = React.useState<IAlternatives[]>([]);
  const [error, setError] = React.useState<string | null>(null);
  const [selectedValue, setSelectedValue] = React.useState<number | 0>(0); // Estado para o Radio selecionado
  const [selectedValue2, setSelectedValue2] = React.useState<number | 0>(0); // Estado para o Radio selecionado
  const [sentencesAtual, setSentencesAtual] = React.useState<Isetences[]>([]);
  const [contPage, setContPage] = React.useState(1);

  // Hook personalizado para paginação
  const usePagination = (items: Isetences[], itemsPerPage: number) => {
    const [currentPage, setCurrentPage] = React.useState(1);
    const totalPages = Math.ceil(items.length / itemsPerPage);

    const currentItems = React.useMemo(() => {
      const start = (currentPage - 1) * itemsPerPage;
      const end = start + itemsPerPage;
      setSentencesAtual(items.slice(start, end));
      return items.slice(start, end);
    }, [items, currentPage, itemsPerPage]);

    const handlePageChange = (_: React.ChangeEvent<unknown>, page: number) => {
      setCurrentPage(page);
    };
    return { currentItems, totalPages, currentPage, handlePageChange };
  };

  // Configuração de paginação
  const itemsPerPage = 2;
  const { currentItems, totalPages, currentPage, handlePageChange } = usePagination(sentences, itemsPerPage);

  // Funcao para salvar a alternativa selecionada
  const handleInsertResponse = async () => {
    setSelectedValue2(0);
    setContPage((prevContPage) => prevContPage + 1);
    setLoading(true);
    try {
      // Criando um array de Promises para as requisições iniciais
      const promises = sentencesAtual.map((item) =>
        postRequest<ResponseResponse>("/modify_responses/", {
          body: {
            school_cnpj: String(access_data.school_cnpj),
            students_re: String(access_data.students_re),
            sentences_id: item.sentence_id,
            alternative_id: 0,
          },
          headers: {},
        })
      );
    
      // Aguarda todas as requisições da primeira etapa finalizarem
      const responses = await Promise.all(promises);
    
      // Verifica se alguma requisição falhou
      const hasError = responses.some((response) => response.status_code !== 200);
      if (hasError) {
        setError("Erro ao salvar uma ou mais respostas! Tente novamente");
        return false;
      }
    
      // Depois que todas as requisições anteriores terminarem, faz a segunda requisição
      const finalResponse = await postRequest<ResponseResponse>("/modify_responses/", {
        body: {
          school_cnpj: String(access_data.school_cnpj),
          students_re: String(access_data.students_re),
          sentences_id: selectedValue,
          alternative_id: selectedValue2,
        },
        headers: {},
      });
    
      // Verifica se a última requisição foi bem-sucedida
      if (finalResponse.status_code !== 200) {
        setError("Erro ao salvar a última resposta! Tente novamente");
        return false;
      }
    
      return true;
    } catch (error) {
      console.error("Erro na requisição:", error);
      setError("Erro ao conectar ao servidor.");
      return false;
    } finally {
      setLoading(false);
    }
    
  }

  // Função para buscar as alternativas da sentence
  const fetchAlternatives = async () => {
    try {
      const response = await getRequest<{ status_code: number; alternatives: IAlternatives[] }>("/get_all_alternatives/");
      // console.log(response.status_code)
      if (response.status_code === 200) {
        // console.log(response.alternatives)
        setalternatives(response.alternatives);
      } else {
        console.error("Erro ao buscar alternativas.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    } finally {
      setLoading(false);
    }
  };

  // Função para buscar dados da API
  const fetchSentences = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await postRequest<SentenceResponse>("/get_all_sentences_active/",
        {
          body: {
            students_re: String(access_data.students_re),
            school_cnpj: String(access_data.school_cnpj),
          },
          headers: {},
        }
      );

      if (response.status_code === 200) {
        setSentences(response.sentences);
      } else {
        setError("Erro ao carregar as frases.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
      setError("Erro ao conectar ao servidor.");
    } finally {
      fetchAlternatives()
      setLoading(false);
    }
  };

  // Função para lidar com a seleção do Radio principal
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue2(0);
    setSelectedValue(Number(event.target.value));
    // const value = event.target.value;
    // console.log("Rádio externo selecionado:", value);
    // setSelectedValue(value);
  };

  // Função para lidar com a seleção dos Rádios dentro do Accordion
  const handleNestedRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue2(Number(event.target.value));
    // console.log("Rádio interno selecionado:", event.target.value);
  };

  React.useEffect(() => {
    fetchSentences();
  }, []);
  
  return (
    <Box 
      sx={{
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center", 
        width: "100%", 
        minHeight: "100vh", 
        backgroundColor: "#A46CBD", 
        backgroundImage: 
          currentItems.length > 0 ? `url(/images/setences/${currentItems[0].image_description}.svg)` : "none", 
        backgroundSize: "contain", 
        backgroundPosition: "center", 
        backgroundRepeat: "no-repeat", 
        padding: 3,
      }}
    >
      {contPage > (sentences.length / 2) && currentItems.length > 0 ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minHeight: "100vh",
            backgroundColor: "#A46CBD",
            backgroundImage: `url(/images/setences/fim.svg)`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            padding: 3,
          }}
        />
      ) : loading ? (
        <CircularProgress sx={{ mt: 4 }} />
      ) : error ? (
        <Alert severity="error" sx={{ mt: 4 }}>{error}</Alert>
      ) : currentItems.length > 0 ? (
        <>
          <RadioGroup
            value={selectedValue}
            onChange={handleRadioChange}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              flexWrap: "wrap",
              gap: 2,
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              padding: 3,
              borderRadius: 2,
              width: "100%",
              maxWidth: "800px",
            }}
          >
            {currentItems.map((item) => (
              <Box key={item.sentence_id} sx={{ mb: 2 }}>
                <FormControlLabel
                  value={String(item.sentence_id)}
                  control={<Radio />}
                  label={item.sentence}
                />
                {selectedValue === Number(item.sentence_id) && (
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>Agora, selecione...</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <RadioGroup
                        onChange={handleNestedRadioChange}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 2,
                          justifyContent: "center",
                        }}
                      >
                        {(alternatives || []).map((alt) => (
                          <FormControlLabel
                            key={alt.alternative_id}
                            value={String(alt.alternative_id)}
                            control={<Radio />}
                            label={alt.alternative}
                          />
                        ))}
                      </RadioGroup>
                    </AccordionDetails>
                  </Accordion>
                )}
              </Box>
            ))}
          </RadioGroup>
  
          {/* Paginação centralizada */}
          {totalPages > 1 && (
            <Box
              sx={{
                mt: 3,
                display: "flex",
                justifyContent: "center",
                width: "100%",
                paddingBottom: 3,
              }}
            >
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                size="large"
                hidePrevButton
                renderItem={(item) => {
                  if (["page", "start-ellipsis", "end-ellipsis"].includes(item.type)) return null; // Oculta os números
                  return (
                    <PaginationItem
                      {...item}
                      disabled={selectedValue2 <= 0}
                      onClick={async (event) => {
                        if (await handleInsertResponse()) {
                          if (item.type === "next" && currentPage < totalPages) {
                            handlePageChange(event, currentPage + 1);
                          }
                        }
                      }}
                      slots={{
                        next: () => <img src="/images/setences/proximo.svg" alt="Próximo" />
                      }}
                    />
                  );
                }}
              />
            </Box>
          )}
        </>
      ) : (
        <Typography variant="h5" sx={{ color: "#fff", mt: 4 }}>
          Não há mais perguntas para você responder no momento!
        </Typography>
      )}
    </Box>
  );  
};

export default SentencesStudents;